
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/categories/[slug]",
      function () {
        return require("private-next-pages/blog/categories/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/categories/[slug]"])
      });
    }
  